import { useTranslation } from "react-i18next"
import { Step } from "react-joyride"
import { CustomBodyText, CustomHeader } from "../manualComponets"
import { ScrollRule } from "../UserManual"

export const consumptionScrollRules: {
	target: string
	opts: ScrollRule
}[] = [
	{
		target: "#header-user-manual",
		opts: {
			containerSelector: "#consumption-layout",
			x: {
				offset: -24,
				align: "end",
			},
			y: {
				offset: 10000,
				align: "end",
			},
		},
	},
	{
		target: "#time-selection",
		opts: {
			containerSelector: "#consumption-layout",
			x: {
				offset: -24,
				align: "end",
			},
			y: {
				offset: 10000,
				align: "end",
			},
		},
	},
	{
		target: "#vessel-selector",
		opts: {
			containerSelector: "#consumption-layout",
			x: {
				offset: 24,
				align: "start",
			},
			y: {
				offset: -24,
				align: "end",
			},
		},
	},
	{
		target: "#fuel-consumption-modes-summary-and-plot",
		opts: {
			containerSelector: "#consumption-layout",
			x: {
				offset: 24,
				align: "start",
			},
			y: {
				offset: 140,
				align: "start",
			},
		},
	},
	{
		target: "#consumption-status-section",
		opts: {
			containerSelector: "#consumption-layout",
			x: {
				offset: 24,
				align: "start",
			},
			y: {
				offset: 140,
				align: "start",
			},
		},
	},
	{
		target: "#total-consumption-baseline-selector",
		opts: {
			containerSelector: "#consumption-layout",
			x: {
				offset: -24,
				align: "end",
			},
			y: {
				offset: 148,
				align: "start",
			},
		},
	},
	{
		target: "#data-labels-button-toggle",
		opts: {
			containerSelector: "#consumption-layout",
			y: {
				offset: 148,
				align: "start",
			},
		},
	},
	{
		target: "#fuel-unit-toggle",
		opts: {
			containerSelector: "#consumption-layout",
			x: {
				offset: 24,
				align: "start",
			},
			y: {
				offset: 148,
				align: "start",
			},
		},
	},
	{
		target: "#grouped-by-fuel-type-toggle",
		opts: {
			containerSelector: "#consumption-layout",
			x: {
				offset: -24,
				align: "end",
			},
			y: {
				offset: 148,
				align: "start",
			},
		},
	},
	{
		target: "#hide-modes-toggle",
		opts: {
			containerSelector: "#consumption-layout",
			y: {
				offset: 148,
				align: "start",
			},
		},
	},
	{
		target: "#summary-body",
		opts: {
			containerSelector: "#consumption-layout",
			x: {
				offset: 24,
				align: "start",
			},
			y: {
				offset: 192,
				align: "start",
			},
		},
	},
	{
		target: "#bar-chart-modes-fuel-consumption",
		opts: {
			containerSelector: "#consumption-layout",
			x: {
				offset: -24,
				align: "end",
			},
			y: {
				offset: 192,
				align: "start",
			},
		},
	},
	{
		target: "#bar-chart-fuel-per-mode",
		opts: {
			containerSelector: "#consumption-layout",
			x: {
				offset: 24,
				align: "start",
			},
			y: {
				offset: 140,
				align: "start",
			},
		},
	},
	{
		target: "#fuelWeatherCard",
		opts: {
			containerSelector: "#consumption-layout",
			x: {
				offset: 24,
				align: "start",
			},
			y: {
				offset: 140,
				align: "start",
			},
		},
	},
	{
		target: "#vessel-track-card",
		opts: {
			containerSelector: "#consumption-layout",
			x: {
				offset: 24,
				align: "start",
			},
			y: {
				offset: 140,
				align: "start",
			},
		},
	},
	{
		target: "#pie-chart-percentage-mode-time-allocation",
		opts: {
			containerSelector: "#consumption-layout",
			x: {
				offset: 24,
				align: "start",
			},
			y: {
				offset: 140,
				align: "start",
			},
		},
	},
	{
		target: "#pie-chart-percentage-shore-power-time-allocation",
		opts: {
			containerSelector: "#consumption-layout",
			x: {
				offset: 24,
				align: "start",
			},
			y: {
				offset: 140,
				align: "start",
			},
		},
	},
	{
		target: "#avg-load-engines-in-use-bar",
		opts: {
			containerSelector: "#consumption-layout",
			x: {
				offset: 24,
				align: "start",
			},
			y: {
				offset: 140,
				align: "start",
			},
		},
	},
	{
		target: "#avg-units-engines-in-use-bar",
		opts: {
			containerSelector: "#consumption-layout",
			x: {
				offset: 24,
				align: "start",
			},
			y: {
				offset: 140,
				align: "start",
			},
		},
	},
	{
		target: "#kgPerNmCard",
		opts: {
			containerSelector: "#consumption-layout",
			x: {
				offset: 24,
				align: "start",
			},
			y: {
				offset: 506,
				align: "start",
			},
		},
	},
	{
		target: "#tonnesPerDayCard",
		opts: {
			containerSelector: "#consumption-layout",
			x: {
				offset: 24,
				align: "start",
			},
			y: {
				offset: 506,
				align: "start",
			},
		},
	},
	{
		target: "#filtering-data",
		opts: {
			containerSelector: "#consumption-layout",
			x: {
				offset: 24,
				align: "start",
			},
			y: {
				offset: 506,
				align: "start",
			},
		},
	},
	{
		target: "#filtering-data",
		opts: {
			containerSelector: "#consumption-layout",
			x: {
				offset: 24,
				align: "start",
			},
			y: {
				offset: 506,
				align: "start",
			},
		},
	},
	{
		target: "#time-aggregation",
		opts: {
			containerSelector: "#consumption-layout",
			x: {
				offset: 24,
				align: "start",
			},
			y: {
				offset: 506,
				align: "start",
			},
		},
	},
	{
		target: "#statistics-card",
		opts: {
			containerSelector: "#consumption-layout",
			x: {
				offset: 24,
				align: "start",
			},
			y: {
				offset: 506,
				align: "start",
			},
		},
	},
	{
		target: "#kgPerNmUniSeaCard",
		opts: {
			containerSelector: "#consumption-layout",
			x: {
				offset: 24,
				align: "end",
			},
			y: {
				offset: 506,
				align: "start",
			},
		},
	},
	// created by AI: Keep the UniSea tonnes/day manual step between efficiency and consumers.
	{
		target: "#tonnesPerDayUniSeaCard",
		opts: {
			containerSelector: "#consumption-layout",
			x: {
				offset: 24,
				align: "end",
			},
			y: {
				offset: 506,
				align: "start",
			},
		},
	},
	{
		target: "#fuel-per-consumer-group-card",
		opts: {
			containerSelector: "#consumption-layout",
			x: {
				offset: 24,
				align: "end",
			},
			y: {
				offset: 506,
				align: "start",
			},
		},
	},
	{
		target: "#generate-report-button",
		opts: {
			containerSelector: "#consumption-layout",
			x: {
				offset: 24,
				align: "start",
			},
			y: { offset: 10000, align: "end" },
		},
	},
]

export const consumptionSteps = (
	translationFunc?: ReturnType<typeof useTranslation>["t"],
	options?: {
		hasUniSeaFeature?: boolean
		isUniSeaVessel?: boolean
		maxNumberOfVessels?: number
		isSensorVesselUniSeaView?: boolean
	}
): Step[] => {
	const t = translationFunc ?? ((text: string) => text)
	const steps: Step[] = [
		{
			target: "#header-user-manual",
			content: (
				<div className={`flex w-125 flex-col`}>
					<CustomHeader>{t("consumption.pageHeader.header")}</CustomHeader>
					<CustomBodyText>{t("consumption.pageHeader.content")}</CustomBodyText>
				</div>
			),
			placement: "left",
			disableBeacon: true,
		},
		{
			target: "#generate-report-button",
			content: (
				<div className={`flex w-125 flex-col`}>
					<CustomHeader>{t("consumption.generateReportButton.header")}</CustomHeader>
					<CustomBodyText>{t("consumption.generateReportButton.content")}</CustomBodyText>
				</div>
			),
			placement: "bottom",
		},
		{
			target: "#data-source-toggler",
			content: (
				<div className={`flex w-125 flex-col`}>
					<CustomHeader>{t("consumption.dataSourceToggler.header")}</CustomHeader>
					<CustomBodyText>{t("consumption.dataSourceToggler.content")}</CustomBodyText>
				</div>
			),
			placement: "bottom",
		},
		{
			target: "#time-selection",
			content: (
				<div className={`flex w-125 flex-col`}>
					<CustomHeader>{t("consumption.timeSelection.header")}</CustomHeader>
					<CustomBodyText>{t("consumption.timeSelection.content")}</CustomBodyText>
				</div>
			),
			placement: "bottom",
		},
		{
			target: "#vessel-selector",
			content: (
				<div className={`flex w-125 flex-col`}>
					<CustomHeader>{t("consumption.vesselSelection.header")}</CustomHeader>
					<CustomBodyText>
						{translationFunc !== undefined && options?.maxNumberOfVessels !== undefined
							? translationFunc("consumption.vesselSelection.content", {
									numberOfVessels: options.maxNumberOfVessels,
								})
							: t("consumption.vesselSelection.content")}
					</CustomBodyText>
				</div>
			),
			placement: "top",
		},
		{
			target: "#consumption-status-section",
			content: (
				<div className={`flex w-[500px] flex-col`}>
					<CustomHeader>{t("consumption.metricsPanel.header")}</CustomHeader>
					<div
						className={`text-dipai-text-primary bg-gray-eee flex flex-col gap-1 rounded-sm border-1 px-2 py-1 text-justify`}
					>
						<p>{t("consumption.metricsPanel.content")}</p>
						<p>{t("consumption.metricsPanel.environmental")}</p>
						<p>{t("consumption.metricsPanel.operation")}</p>
						<p>{t("consumption.metricsPanel.transit")}</p>
					</div>
				</div>
			),
			placement: "bottom",
		},
		{
			target: "#fuel-consumption-modes-summary-and-plot",
			content: (
				<div className={`flex w-125 flex-col`}>
					<CustomHeader>
						{t("consumption.fuelConsumptionModesSummaryAndPlot.header")}
					</CustomHeader>
					<CustomBodyText>
						{t("consumption.fuelConsumptionModesSummaryAndPlot.content")}
					</CustomBodyText>
				</div>
			),
			placement: "bottom",
		},
		{
			target: "#total-consumption-baseline-selector",
			content: (
				<div className={`flex w-125 flex-col`}>
					<CustomHeader>{t("consumption.baselineSelector.header")}</CustomHeader>
					<CustomBodyText>{t("consumption.baselineSelector.content")}</CustomBodyText>
				</div>
			),
			placement: "bottom",
		},
		{
			target: "#grouped-by-fuel-type-toggle",
			content: (
				<div className={`flex w-125 flex-col`}>
					<CustomHeader>{t("consumption.groupedByFuelTypeToggle.header")}</CustomHeader>
					<CustomBodyText>
						{t("consumption.groupedByFuelTypeToggle.content")}
					</CustomBodyText>
				</div>
			),
			placement: "bottom-end",
		},
		{
			target: "#fuel-unit-toggle",
			content: (
				<div className={`flex w-125 flex-col`}>
					<CustomHeader>{t("consumption.fuelUnitToggle.header")}</CustomHeader>
					<CustomBodyText>{t("consumption.fuelUnitToggle.content")}</CustomBodyText>
				</div>
			),
			placement: "bottom-end",
		},
		{
			target: "#hide-modes-toggle",
			content: (
				<div className={`flex w-125 flex-col`}>
					<CustomHeader>{t("consumption.hideModesToggle.header")}</CustomHeader>
					<CustomBodyText>{t("consumption.hideModesToggle.content")}</CustomBodyText>
				</div>
			),
			placement: "bottom-end",
		},
		{
			target: "#data-labels-button-toggle",
			content: (
				<div className={`flex w-125 flex-col`}>
					<CustomHeader>{t("consumption.dataLabelsButtonToggle.header")}</CustomHeader>
					<CustomBodyText>
						{t("consumption.dataLabelsButtonToggle.content")}
					</CustomBodyText>
				</div>
			),
			placement: "bottom-end",
		},
		{
			target: "#summary-body",
			content: (
				<div className={`flex w-125 flex-col`}>
					<CustomHeader>{t("consumption.summaryBody.header")}</CustomHeader>
					<CustomBodyText>{t("consumption.summaryBody.content")}</CustomBodyText>
				</div>
			),
			placement: "bottom-start",
		},
		{
			target: "#bar-chart-modes-fuel-consumption",
			content: (
				<div className={`flex w-125 flex-col`}>
					<CustomHeader>
						{t("consumption.barChartModesFuelConsumption.header")}
					</CustomHeader>
					<CustomBodyText>
						{t("consumption.barChartModesFuelConsumption.content")}
					</CustomBodyText>
				</div>
			),
			placement: "bottom",
		},
		{
			target: "#fuelWeatherCard",
			content: (
				<div className={`flex w-125 flex-col`}>
					<CustomHeader>{t("consumption.weatherCard.header")}</CustomHeader>
					<CustomBodyText>{t("consumption.weatherCard.content")}</CustomBodyText>
				</div>
			),
			placement: "bottom",
		},
		{
			target: "#vessel-track-card",
			content: (
				<div className={`flex w-125 flex-col`}>
					<CustomHeader>{t("consumption.vesselTrackCard.header")}</CustomHeader>
					<CustomBodyText>{t("consumption.vesselTrackCard.content")}</CustomBodyText>
				</div>
			),
			placement: "bottom",
		},
		{
			target: "#bar-chart-fuel-per-mode",
			content: (
				<div className={`flex w-125 flex-col`}>
					<CustomHeader>{t("consumption.barChartFuelPerMode.header")}</CustomHeader>
					<CustomBodyText>{t("consumption.barChartFuelPerMode.content")}</CustomBodyText>
				</div>
			),
			placement: "bottom",
		},
		{
			target: "#pie-chart-percentage-mode-time-allocation",
			content: (
				<div className={`flex w-125 flex-col`}>
					<CustomHeader>
						{t("consumption.pieChartPercentageModeTimeAllocation.header")}
					</CustomHeader>
					<CustomBodyText>
						{t("consumption.pieChartPercentageModeTimeAllocation.content")}
					</CustomBodyText>
				</div>
			),
			placement: "bottom",
		},
		{
			target: "#pie-chart-percentage-shore-power-time-allocation",
			content: (
				<div className={`flex w-125 flex-col`}>
					<CustomHeader>
						{t("consumption.pieChartPercentageShorePowerTimeAllocation.header")}
					</CustomHeader>
					<CustomBodyText>
						{t("consumption.pieChartPercentageShorePowerTimeAllocation.content")}
					</CustomBodyText>
				</div>
			),
			placement: "bottom",
		},
		{
			target: "#avg-load-engines-in-use-bar",
			content: (
				<div className={`flex w-125 flex-col`}>
					<CustomHeader>{t("consumption.avgLoadEnginesInUseBar.header")}</CustomHeader>
					<CustomBodyText>
						{t("consumption.avgLoadEnginesInUseBar.content")}
					</CustomBodyText>
				</div>
			),
			placement: "bottom",
		},
		{
			target: "#avg-units-engines-in-use-bar",
			content: (
				<div className={`flex w-125 flex-col`}>
					<CustomHeader>{t("consumption.avgUnitsEnginesInUseBar.header")}</CustomHeader>
					<CustomBodyText>
						{t("consumption.avgUnitsEnginesInUseBar.content")}
					</CustomBodyText>
				</div>
			),
			placement: "bottom",
		},
		{
			target: "#kgPerNmCard",
			content: (
				<div className={`flex w-125 flex-col`}>
					<CustomHeader>{t("consumption.fuelEfficiencyAnalysis.header")}</CustomHeader>
					<CustomBodyText>
						{t("consumption.fuelEfficiencyAnalysis.content")}
					</CustomBodyText>
				</div>
			),
			placement: "top",
		},
		{
			target: "#time-aggregation",
			content: (
				<div className={`flex w-125 flex-col`}>
					<CustomHeader>{t("efficiency.timeAggregation.header")}</CustomHeader>
					<CustomBodyText>{t("efficiency.timeAggregation.content")}</CustomBodyText>
				</div>
			),
			placement: "top",
		},
		{
			target: "#filtering-data",
			content: (
				<div className={`flex w-125 flex-col`}>
					<CustomHeader>{t("efficiency.filteringData.header")}</CustomHeader>
					<CustomBodyText>{t("efficiency.filteringData.content")}</CustomBodyText>
				</div>
			),
			placement: "top",
		},
		{
			target: "#statistics-card",
			content: (
				<div className={`flex w-125 flex-col`}>
					<CustomHeader>{t("efficiency.trendVariation.header")}</CustomHeader>
					<CustomBodyText>{t("efficiency.trendVariation.content")}</CustomBodyText>
				</div>
			),
			placement: "top",
		},
		{
			target: "#tonnesPerDayCard",
			content: (
				<div className={`flex w-125 flex-col`}>
					<CustomHeader>{t("consumption.fuelConsumptionAnalysis.header")}</CustomHeader>
					<CustomBodyText>
						{t("consumption.fuelConsumptionAnalysis.content")}
					</CustomBodyText>
				</div>
			),
			placement: "top",
		},
		{
			target: "#kgPerNmUniSeaCard",
			content: (
				<div className={`flex w-125 flex-col`}>
					<CustomHeader>
						{t("consumption.fuelEfficiencyAnalysisUniSea.header")}
					</CustomHeader>
					<CustomBodyText>
						{t("consumption.fuelEfficiencyAnalysisUniSea.content")}
					</CustomBodyText>
				</div>
			),
			placement: "top",
		},
		// created by AI: UniSea-only tonnes/day plot uses noon-report fuel consumption data.
		{
			target: "#tonnesPerDayUniSeaCard",
			content: (
				<div className={`flex w-125 flex-col`}>
					<CustomHeader>
						{t("consumption.fuelConsumptionAnalysisUniSea.header")}
					</CustomHeader>
					<CustomBodyText>
						{t("consumption.fuelConsumptionAnalysisUniSea.content")}
					</CustomBodyText>
				</div>
			),
			placement: "top",
		},
		{
			target: "#fuel-per-consumer-group-card",
			content: (
				<div className={`flex w-125 flex-col`}>
					<CustomHeader>{t("consumption.fuelPerConsumerGroup.header")}</CustomHeader>
					<CustomBodyText>{t("consumption.fuelPerConsumerGroup.content")}</CustomBodyText>
				</div>
			),
			placement: "top",
		},
	]

	if (options?.isUniSeaVessel === true) {
		return steps.filter(
			(step) =>
				typeof step.target === "string" &&
				toRemoveUniSeaVessel.includes(step.target) === false
		)
	}

	if (options?.hasUniSeaFeature !== true) {
		return steps.filter(
			(step) =>
				typeof step.target === "string" &&
				toRemoveNoUniSeaFeature.includes(step.target) === false
		)
	}

	if (options?.isSensorVesselUniSeaView !== true) {
		return steps.filter(
			(step) =>
				typeof step.target === "string" &&
				toRemoveSensorVesselNonUniSeaView.includes(step.target) === false
		)
	}
	return steps.filter((step) => step.target !== "#total-consumption-baseline-selector")
}

const toRemoveSensorVesselNonUniSeaView = [
	"#pie-chart-percentage-shore-power-time-allocation",
	"#kgPerNmUniSeaCard",
	"#tonnesPerDayUniSeaCard",
	"#fuel-per-consumer-group-card",
]

const toRemoveNoUniSeaFeature = [
	"#data-source-toggler",
	"#pie-chart-percentage-shore-power-time-allocation",
	"#kgPerNmUniSeaCard",
	"#tonnesPerDayUniSeaCard",
	"#fuel-per-consumer-group-card",
]

const toRemoveUniSeaVessel = [
	"#data-source-toggler",
	"#total-consumption-baseline-selector",
	"#avg-load-engines-in-use-bar",
	"#avg-units-engines-in-use-bar",
	"#kgPerNmCard",
	"#tonnesPerDayCard",
	"#filtering-data",
	"#time-aggregation",
	"#statistics-card",
]
